export default "__VITE_ASSET__DIhJmlYH__"